<template>
  <div class="card text-center py-5">
    <i class="fad" :class="['text-' + type, 'fa-' + icon]"></i>
    <ICountUp
      class="count-up"
      :delay="delay"
      :endVal="endVal"
      :options="options"
      @ready="onReady"
    />
    <div class="label" :class="['text-' + type]">
      {{ label }}
    </div>
  </div>
</template>

<script type="text/babel">
import ICountUp from "vue-countup-v2";
export default {
  components: {
    ICountUp,
  },
  props: {
    endVal: 0,
    label: { default: "" },
    icon: { default: "shield-check" },
    type: { default: "success" },
    propsSuffix: { default: "" },
    propsPrefix: { default: "" },
  },
  data() {
    return {
      delay: 1500,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        suffix: this.propsSuffix,
        prefix: this.propsPrefix,
      },
    };
  },
  methods: {
    onReady: function (instance, CountUp) {
      const that = this;
      instance.update(that.endVal);
    },
  },
};
</script>
<style lang="scss" scoped>
.fad {
  font-size: 80px;
}
.count-up {
  font-weight: 900;
  font-size: 50px;
}
.label {
  font-weight: bold;
  font-size: 40px;
  font-weight: 100;
}
</style>